import { IconHeart } from '@tabler/icons-react';
import { Text } from '@/components/ui/core';
import { Box, Group } from '@/components/ui/layout';
import { AppUpdateNotice } from '@/components/main/AppUpdateNotice';
import { useAppUpdateStore } from '@/domain/appUpdate';

export default function MainFooter() {
  const currentYear = new Date().getFullYear();

  // A required update takes the whole footer. Sharing the row with the
  // copyright line put two centred blocks on top of each other, and the
  // copyright is not what someone needs to read while being reloaded.
  const mandatory = useAppUpdateStore((s) => s.mandatory);

  return (
    <Box
      component="footer"
      px="md"
      py="sm"
      style={{
        textAlign: 'center',
        borderTop: mandatory
          ? '2px solid var(--mantine-color-red-6)'
          : '1px solid var(--mantine-color-gray-3)',
      }}
    >
      <Group justify="center" gap="sm" wrap="nowrap">
        {!mandatory && (
          <Text size="sm" c="dimmed">
            Made with <IconHeart size={14} style={{ verticalAlign: 'middle', color: 'var(--mantine-color-red-6)' }} /> by Acts Christian Church &copy; {currentYear}
          </Text>
        )}

        {/* Renders nothing until the watcher finds a newer build. */}
        <AppUpdateNotice />
      </Group>
    </Box>
  );
}
